export default __webpack_public_path__ + "img/9f995c3919355c732614a11f5baca9b1.png";